import { render, staticRenderFns } from "./PersonsOfficesIcon.vue?vue&type=template&id=08446f1a&"
import script from "./PersonsOfficesIcon.vue?vue&type=script&lang=js&"
export * from "./PersonsOfficesIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports